// extracted by mini-css-extract-plugin
export default {"wrapper":"LootboxRerollIcon_wrapper","reroll":"LootboxRerollIcon_reroll"};